<script>
import Loading from '../common/Loading.vue';

export default {
    props: {
        repository: {
            type: Function,
            required: true,
        },
        params: {
            type: Array,
            required: false,
            default: () => [],
        },
        callback: {
            type: Function,
            required: false,
        },
        interval: {
            type: Number,
            required: false,
        },
        disableLoader: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            error: false,
            data: null,
            reloadHandle: undefined,
        }
    },
    watch: {
        params(newParams, oldParams) {
            if (JSON.stringify(newParams) === JSON.stringify(oldParams)) {
                return;
            }

            this.loading = true;
            this.load();
        },
    },
    created() {
        this.load();
    },
    destroyed() {
        clearTimeout(this.reloadHandle);
        this.reloadHandle = undefined;
    },
    methods: {
        load() {
            return new Promise((resolve, reject) => {
                clearTimeout(this.reloadHandle);
                let callback = data => {
                    this.data = data;
                    this.loading = false;
                    if (this.callback) {
                        this.callback(data);
                    }
                    resolve(data);
                };
                let errorHandler = () => {
                    this.error = true;
                    this.loading = false;
                    reject();
                };
                this.repository(...this.params).then(callback).catch(errorHandler);
            });
        },
        remove(element) {
            if (this.data === null) {
                return;
            }

            this.data.splice(this.data.indexOf(element), 1);
        },
    },
    render(createElement) {
        if (this.error) {
            this.$notify.error('error.loadingData');

            return createElement('');
        }

        if (this.loading && !this.disableLoader) {
            return createElement(Loading);
        }

        return this.$scopedSlots.default({
            data: this.data,
            reload: this.load,
            loading: this.loading,
            remove: this.remove,
        });
    }
}
</script>
